<!--
/*
 * @Author: your name
 * @Date: 2021-07-05 15:57:34
 * @LastEditTime: 2022-11-01 09:51:11
 * @LastEditors: 谢树和 shuhe.xie@southgis.com
 * @Description: In User Settings Edit
 * @FilePath: \maine:\git\xadc\src\views\JobUnitQuery\JobUnitQueryHome.vue
 * @Description: 测绘作业单位查询 - 首页
 */
 -->

<template>
  <div id="job-unit-query" class="job-unit-query">
    <head-search
      v-model="searchValue"
      @searchQuery="search"
      @searchCancel="onCancel"
    ></head-search>
    <div class="job-unit-query-middle">
      <div
        class="job-middle-box"
        v-for="(item, index) of middleData"
        :key="index"
        @click="middleClicked(index)"
      >
        <van-image width="46px" height="46px" :src="middleSrc(index)" />
        <div class="job-middle-right">
          <div class="job-middle-title">{{ index }}测绘资质</div>
          <div class="job-middle-unit">
            已备案{{ index }}资质单位共 <span>{{ item }}</span> 家
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="job-unit-query-box" v-else>
      <no-data v-if="list.length == 0"></no-data>
      <van-pull-refresh v-model="refreshConfig.refreshing" @refresh="onRefresh">
        <van-list
          class="job-list"
          v-model="refreshConfig.loading"
          :finished="refreshConfig.finished"
          :finished-text="refreshConfig.finishedText"
          :error.sync="refreshConfig.error"
          :error-text="refreshConfig.errorText"
          @load="onLoad"
        >
          <div class="job-list-item-box" v-for="(item, idx) in list" :key="idx">
            <div class="content">
              <div class="title">{{ item[columns[0].key] }}</div>
              <div v-for="(column, index) in columns" :key="index">
                <div class="cell-box" v-if="column.key != columns[0].key">
                  <span class="cell-box-title">{{ column.label }}</span>
                  <div class="cell-box-value">
                    {{ item[column.key] }}
                  </div>
                </div>
              </div>
              <van-cell
                title="详情"
                is-link
                class="detail-btn"
                title-class="detail-title"
                @click="itemClicked(item)"
              />
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div> -->
  </div>
</template>

<script>
import HeadSearch from '@/components/HeadSearch.vue'
import api from '@/utils/api/jobUnitQuery.api.js'
import listMixins from '@/mixins/comListMixins'
import moduleMixins from '@/mixins/moduleMixins'
export default {
  name: 'jobUnitQueryHome',
  mixins: [listMixins, moduleMixins],
  components: {
    HeadSearch,
  },
  props: {},
  data() {
    return {
      searchValue: '', // 搜索条件
      list: [],
      columns: [], // 列表子项的左侧标题数组
      ismiddle: false, //是否有中间页
      middleData: {},
      unitLevel: '',
      // show: true,
      // toNext: false,
      title: ''
    }
  },
  watch: {},
  computed: {
    navTitle() {
      return this.$route.query.title
    }
  },
  methods: {
    // 搜索测绘作业
    search(val) {
      console.log('搜索值', val)
      this.searchValue = val
      this.$router.push({
        name: 'jobUnitQueryList',
        query: {
          val,
          unitLevel: this.unitLevel
        }
      })
    },
    // 取消搜索
    onCancel() {
      console.log('点击取消')
      this.searchValue = ''
    },
    middleSrc(val) {
      switch (val) {
        case '甲级':
          return require('@/assets/img/jobUnitQuery/middle1.png')
        case '乙级':
          return require('@/assets/img/jobUnitQuery/middle2.png')
        case '丙级':
          return require('@/assets/img/jobUnitQuery/middle3.png')
        case '丁级':
          return require('@/assets/img/jobUnitQuery/middle4.png')
      }
    },
    middleClicked(val) {
      this.unitLevel = val
      this.$router.push({
        name: 'jobUnitQueryList',
        query: {
          val: this.searchValue,
          unitLevel: this.unitLevel
        }
      })
    },
    // pushStateFun() {
    //   if (!this.toNext) {
    //     this.show = false
    //   } else {
    //     this.toNext = false
    //   }
    // },
    // prevent_back() {
    //   let path = this.$route.fullPath
    //   // 判断是否开启了后端支持
    //   if (this.$router.mode == 'hash') {
    //     path = '#' + path
    //   }
    //   var state = {
    //     title: this.navTitle,
    //     url: path //要禁掉的页面
    //   }
    //   window.history.pushState(state, null, path) //要禁掉的页面
    //   window.addEventListener('popstate', this.pushStateFun, false)
    // },
    // remove_back() {
    //   window.removeEventListener('popstate', this.pushStateFun, false)
    // }
  },
  created() { 
  },
  mounted() {
    if (this.$route.query.middle == '0') {
      this.ismiddle = false
      // TODO: 不显示资质页面
    } else {
      this.ismiddle = true
    }
    api.getJobUnitQuerymiddle().then(res => {
      this.middleData = res.data
    })
  }
}
</script>
<style lang="scss" scoped>
.job-unit-query {
  height: 100vh;
  width: 100%;
  .job-unit-query-middle {
    padding-top: 60px;
    padding-left: 16px;
    padding-right: 16px;
    .job-middle-box {
      display: flex;
      background: #ffffff;
      box-shadow: 0px 2px 5px 0px rgba(124, 130, 140, 0.2);
      border-radius: 5px;
      padding: 20px 23px;
      margin-bottom: 15px;
      .job-middle-right {
        padding-left: 23px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .job-middle-title {
          font-size: 18px;
          font-weight: bold;
          color: #333333;
          line-height: 21px;
        }
        .job-middle-unit {
          font-size: 14px;
          font-weight: 400;
          color: #999999;
          line-height: 21px;
          span {
            color: #2a84f4;
          }
        }
      }
    }
  }
  .job-unit-query-box {
    // height: calc(100vh - 47px);
    padding-top: 47px;
    background: #f1f3f6;
    // overflow: auto;
    .empty {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      padding-top: 100px;
      .empty-icon {
        width: 186px;
        height: 131px;
      }
      .empty-text {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #999999;
        padding-top: 10px;
      }
    }
    .job-list {
      .job-list-item-box {
        margin: 0px 16px;
        padding-top: 20px;
        .content {
          box-shadow: 0px 2px 5px 0px rgba(124, 130, 140, 0.2);
          border-radius: 5px;
          background: #ffffff;
          .title {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #333333;
            padding: 15px 0px 17px 15px;
          }
          .cell-box {
            display: flex;
            padding: 0px 15px 17px 10px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
            width: calc(100% - 25px);
            .cell-box-title {
              color: #999999;
              width: 25%;
              display: flex;
              justify-content: flex-end;
            }
            .cell-box-value {
              width: 75%;
              padding-left: 18px;
            }
          }
          .detail-btn {
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            border-top: 1px solid #f1f3f6;
          }
          .detail-title {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
          }
        }
      }
    }
  }
}
</style>
